import { GraphQLClient } from "graphql-request";

const client = new GraphQLClient("/admin/graphql", {
  headers: {
    "Content-Type": "application/json",
  },
});

export default client;
